/**
 * @param {Event} e - the event object
 * @param {Array<String>} matchingKeys - Array of strings
 * @param {Function} callback - the callback function to run
 * @param {Boolean} preventDefault - whether to prevent the default action of the event
 */

export default function(e, matchingKeys, callback, preventDefault = false) {
    if (preventDefault) e.preventDefault()
        
    if (matchingKeys.includes(e.key)) {
        if (e.key === "Tab" && !e.shiftKey || e.key !== "Tab") {
            callback()
        }
    }
    if (matchingKeys.includes("ShiftTab") && (e.key === "Tab" && e.shiftKey)) {
        callback()
    }
}